import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as envProd from 'src/environments/environment.prod';
import { ListResponse, SingleResponse } from '../interfaces/responses.interface';
import { Observable, Subject, tap } from 'rxjs';
import { Link } from '../interfaces/links.interface';
import { isValid } from '../utils/code-utils';
@Injectable({
  providedIn: 'root',
})
export class LinksService  {
  readonly menuChanges = new Subject<void>();
  refreshMenu(): void { this.menuChanges.next(); }
  refreshAfterSuccess(response: { code: number | string }): void {
    if (isValid(response?.code)) this.refreshMenu();
  }
  constructor() {}

  // #region servicios y otras dependencias

  private http = inject(HttpClient);

  // #endregion servicios y otras dependencias

  // #region variables

  readonly API_URL = environment.API_URL;

  index(): Observable<ListResponse<Link>> {
    return this.http.get<ListResponse<Link>>(`${this.API_URL}/links`);
  }
  
  paginated(body): Observable<ListResponse<Link>> {
    return this.http.post<ListResponse<Link>>(`${this.API_URL}/links/paginated`, body);
  }

  arbol(): Observable<ListResponse<Link>> {
    return this.http.get<ListResponse<Link>>(`${this.API_URL}/links/arbol`);
  }

  getById(id: number): Observable<SingleResponse<Link>> {
    return this.http.get<SingleResponse<Link>>(`${this.API_URL}/links/view/${id}`);
  }

  create(data: Link): Observable<SingleResponse<Link>> {
    return this.http.post<SingleResponse<Link>>(`${this.API_URL}/links/create`, { data })
      .pipe(tap(response => this.refreshAfterSuccess(response)));
  }

  update(data: Link): Observable<SingleResponse<Link>> {
    return this.http.put<SingleResponse<Link>>(`${this.API_URL}/links/update`, { data })
      .pipe(tap(response => this.refreshAfterSuccess(response)));
  }

  reorder(data: Link[]): Observable<SingleResponse<Link[]>> {
    return this.http.post<SingleResponse<Link[]>>(`${this.API_URL}/links/reorder`, { data })
      .pipe(tap(response => this.refreshAfterSuccess(response)));
  }

  delete(id: number): Observable<SingleResponse<void>> {
    return this.http.delete<SingleResponse<void>>(`${this.API_URL}/links/delete/${id}`)
      .pipe(tap(response => this.refreshAfterSuccess(response)));
  }
}
